import React, { useState } from 'react'
import styled from 'styled-components'
import { theme } from '../../theme/theme'
import { FormInput } from './FormInput'
import { formatDisplayDate } from '../../utils/dateUtils'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
`

const DateTimeDisplay = styled.div`
  display: flex;
  align-items: center;
  padding: ${theme.spacing.sm};
  border-radius: ${theme.borderRadius.sm};
  cursor: pointer;
  transition: ${theme.transitions.default};
  
  &:hover {
    background-color: ${({ theme }) => theme.colors.surfaceHover};
  }
`

const DateTimeText = styled.span`
  font-size: ${theme.typography.md};
  color: ${({ theme }) => theme.colors.text};
`

const InputsContainer = styled.div`
  display: flex;
  gap: ${theme.spacing.sm};
  flex-direction: column;
  
  @media (min-width: 480px) {
    flex-direction: row;
  }
`

interface DateTimeInputsProps {
  date: string
  time?: string
  onDateChange: (date: string) => void
  onTimeChange?: (time: string) => void
  showTimeInput?: boolean
  displayOnly?: boolean
  className?: string
}

export const DateTimeInputs: React.FC<DateTimeInputsProps> = ({
  date,
  time = '',
  onDateChange,
  onTimeChange,
  showTimeInput = true,
  displayOnly = false,
  className,
}) => {
  const [isExpanded, setIsExpanded] = useState(false)

  if (displayOnly || !isExpanded) {
    return (
      <Container className={className}>
        <DateTimeDisplay onClick={() => !displayOnly && setIsExpanded(true)}>
          <DateTimeText>{formatDisplayDate(date, time)}</DateTimeText>
        </DateTimeDisplay>
      </Container>
    )
  }

  return (
    <Container className={className}>
      <InputsContainer>
        <FormInput
          variant="borderless"
          type="date"
          value={date}
          onChange={(e) => onDateChange(e.target.value)}
          required
        />
        {showTimeInput && onTimeChange && (
          <FormInput
            variant="borderless"
            type="time"
            value={time}
            onChange={(e) => onTimeChange(e.target.value)}
            onBlur={() => setIsExpanded(false)}
          />
        )}
      </InputsContainer>
    </Container>
  )
}
